const videoType = [
  {
    name: 'm3u8',
    type: 'application/x-mpegURL',
    id: 1
  },
  {
    name: 'mp4',
    type: 'video/mp4',
    id: 2
  },
  {
    name: 'flv',
    type: 'video/flv',
    id: 3
  },
  {
    name: 'mpd',
    type: 'application/dash+xml',
    id: 4
  },
  {
    name: 'rtmp',
    type: 'rtmp/flv',
    id: 5
  }
]

export default videoType
